import { Component, OnInit, ViewChild } from '@angular/core';
import {
  addIdsToArray,
  ChartConfiguration,
  CustomColumn,
  CustomTableComponent,
} from 'src/app/components/table/custom-table/custom-table.component';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { CustomRadio } from 'src/app/components/radio-button/custom/custom.radio';
import { Dashboard } from 'src/app/beans/dashboard/dashboard';
import { User } from 'src/app/beans/login/user/user.bean';
import { Site } from 'src/app/beans/site/site.bean';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { DashboardFilter } from 'src/app/beans/dashboard/dashboard.filter.bean';
import { SiteSelect } from 'src/app/components/select/site/site-select/site.select';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DeviceStatusDialog } from 'src/app/dialogs/device-status/device.status.dialog';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage implements OnInit {
  @ViewChild('siteTable') siteTable: CustomTableComponent;
  @ViewChild('serviceTable') serviceTable: CustomTableComponent;
  @ViewChild('deviceTable') deviceTable: CustomTableComponent;

  dashboardFilters: DashboardFilter[] = [
    {
      name: 'radio.dashboard.values.ticket',
      value: 0,
    },
    {
      name: 'radio.dashboard.values.book',
      value: 1,
    },
    {
      name: 'radio.dashboard.values.ticket_book',
      value: 2,
    },
  ];

  siteColumns: CustomColumn[] = [
    {
      isId: true,
      label: 'id',
      name: 'id',
      display: (val: any) => false,
    },
    {
      label: 'type',
      name: 'tables.dashboard.sites.labels.type',
      display: (val: any) => this.showType(),
    },
    {
      label: 'openCounters',
      name: 'tables.dashboard.sites.labels.openCounters',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'issued',
      name: 'tables.dashboard.sites.labels.issued',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'served',
      name: 'tables.dashboard.sites.labels.served',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'quits',
      name: 'tables.dashboard.sites.labels.quits',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'waiting',
      name: 'tables.dashboard.sites.labels.waiting',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'avgWaitTime',
      name: 'tables.dashboard.sites.labels.avgWaitTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'maxWaitTime',
      name: 'tables.dashboard.sites.labels.maxWaitTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'avgWaitTimeToServe',
      name: 'tables.dashboard.sites.labels.avgWaitTimeToServe',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'maxWaitTimeToServe',
      name: 'tables.dashboard.sites.labels.maxWaitTimeToServe',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'avgServiceTime',
      name: 'tables.dashboard.sites.labels.avgServiceTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'servedOverLimit1',
      name: 'tables.dashboard.sites.labels.servedOverLimit1',
      pipe: (value: any) => this._pipe.tables().is_not_null(value, '-'),
    },
    {
      label: 'servedOverLimit2',
      name: 'tables.dashboard.sites.labels.servedOverLimit2',
      pipe: (value: any) => this._pipe.tables().is_not_null(value, '-'),
    },
    {
      label: 'toServeOverLimit1',
      name: 'tables.dashboard.sites.labels.toServeOverLimit1',
      pipe: (value: any) => this._pipe.tables().is_not_null(value, '-'),
    },
    {
      label: 'toServeOverLimit2',
      name: 'tables.dashboard.sites.labels.toServeOverLimit2',
      pipe: (value: any) => this._pipe.tables().is_not_null(value, '-'),
    },
  ];

  // chartsConf: ChartConfiguration[] = [
  //   {
  //     id: "ch1",
  //     labels    :   {
  //       isColumn: false
  //     },
  //     columns   :   [
  //       {
  //         label : "openCounters",
  //         name  : "tables.dashboard.sites.labels.openCounters",
  //       },
  //       {
  //         label : "issued",
  //         name  : "tables.dashboard.sites.labels.issued",
  //       },
  //       {
  //         label : "served",
  //         name  : "tables.dashboard.sites.labels.served",
  //       },
  //       {
  //         label : "quits",
  //         name  : "tables.dashboard.sites.labels.quits",
  //       },
  //       {
  //         label : "waiting",
  //         name  : "tables.dashboard.sites.labels.waiting",
  //       },
  //     ] ,
  //     type      : 'bar'
  //   },
  //   {
  //     id: "ch2",
  //     labels    :   {
  //       isColumn: false
  //     },
  //     columns   :   [
  //       {
  //         label       : "avgWaitTime",
  //         name        : "tables.dashboard.sites.labels.avgWaitTime",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "maxWaitTime",
  //         name        : "tables.dashboard.sites.labels.maxWaitTime",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "avgWaitTimeToServe",
  //         name        : "tables.dashboard.sites.labels.avgWaitTimeToServe",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "maxWaitTimeToServe",
  //         name        : "tables.dashboard.sites.labels.maxWaitTimeToServe",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label : "avgServiceTime",
  //         name  : "tables.dashboard.sites.labels.avgServiceTime",
  //         pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       }
  //     ] ,
  //     type      : 'bar'
  //   }
  // ]

  servicesColumns: CustomColumn[] = [
    {
      isId: true,
      label: 'id',
      name: 'id',
      display: (val: any) => false,
    },
    {
      label: 'type',
      name: 'tables.dashboard.sites.labels.type',
      display: (val: any) => this.showType(),
    },
    {
      label: 'serviceName',
      name: 'tables.dashboard.services.labels.serviceName',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'opening',
      name: 'tables.dashboard.services.labels.opening',
      pipe: (value: any) => this._pipe.tables().excapeText(value, 'CHIUSO'),
    },
    {
      label: 'issued',
      name: 'tables.dashboard.services.labels.issued',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'served',
      name: 'tables.dashboard.services.labels.served',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'quits',
      name: 'tables.dashboard.services.labels.quits',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'waiting',
      name: 'tables.dashboard.services.labels.waiting',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'avgWaitTime',
      name: 'tables.dashboard.services.labels.avgWaitTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'maxWaitTime',
      name: 'tables.dashboard.services.labels.maxWaitTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'avgWaitTimeToServe',
      name: 'tables.dashboard.sites.labels.avgWaitTimeToServe',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'maxWaitTimeToServe',
      name: 'tables.dashboard.sites.labels.maxWaitTimeToServe',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'avgServiceTime',
      name: 'tables.dashboard.services.labels.avgServiceTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
  ];

  // chartsConf_service: ChartConfiguration[] = [
  //   {
  //     id: "ch3",
  //     labels    :   {
  //       isColumn: false
  //     },
  //     columns   :   [
  //       {
  //         label : "issued",
  //         name  : "tables.dashboard.services.labels.issued",
  //       },
  //       {
  //         label : "served",
  //         name  : "tables.dashboard.services.labels.served",
  //       },
  //       {
  //         label : "quits",
  //         name  : "tables.dashboard.services.labels.quits",
  //       },

  //       {
  //         label : "waiting",
  //         name  : "tables.dashboard.services.labels.waiting",
  //       },
  //     ] ,
  //     type      : 'bar'
  //   },
  //   {
  //     id: "ch4",
  //     labels    :   {
  //       isColumn: false
  //     },
  //     columns   :   [
  //       {
  //         label : "avgWaitTime",
  //         name  : "tables.dashboard.services.labels.avgWaitTime",
  //         pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "maxWaitTime",
  //         name        : "tables.dashboard.services.labels.maxWaitTime",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "avgWaitTimeToServe",
  //         name        : "tables.dashboard.sites.labels.avgWaitTimeToServe",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "maxWaitTimeToServe",
  //         name        : "tables.dashboard.sites.labels.maxWaitTimeToServe",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label : "avgServiceTime",
  //         name  : "tables.dashboard.services.labels.avgServiceTime",
  //         pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       }
  //     ] ,
  //     type      : 'bar'
  //   }
  // ]

  countersColumns: CustomColumn[] = [
    {
      isId: true,
      label: 'id',
      name: 'id',
      display: (val: any) => false,
    },
    {
      label: 'type',
      name: 'tables.dashboard.sites.labels.type',
      display: (val: any) => this.showType(),
    },
    {
      label: 'counterName',
      name: 'tables.dashboard.counters.labels.counterName',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'opened',
      name: 'tables.dashboard.counters.labels.opened',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'openingTime',
      name: 'tables.dashboard.counters.labels.openingTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
    },
    {
      label: 'state',
      name: 'tables.dashboard.counters.labels.state',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'served',
      name: 'tables.dashboard.counters.labels.served',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'lastCalledTicket',
      name: 'tables.dashboard.counters.labels.lastCalledTicket',
      pipe: (value: any) => this._pipe.tables().excapeText(value, '-'),
    },
    {
      label: 'avgWaitTime',
      name: 'tables.dashboard.counters.labels.avgWaitTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label: 'maxWaitTime',
      name: 'tables.dashboard.counters.labels.maxWaitTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
    /*
    {
      label       : "avgWaitTimeToServe",
      name        : "tables.dashboard.sites.labels.avgWaitTimeToServe",
      pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      style_filter: (time: any) => this._pipe.tables().style_warner(time, 1250, 1800),
    },
    {
      label : "maxWaitTimeToServe",
      name  : "tables.dashboard.sites.labels.maxWaitTimeToServe",
      pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      style_filter: (time: any) => this._pipe.tables().style_warner(time, 1250, 1800),
    },
    */
    {
      label: 'avgServiceTime',
      name: 'tables.dashboard.counters.labels.avgServiceTime',
      pipe: (time: any) =>
        this._pipe.tables().time_pipe_seconds_to_time(time, '-'),
      style_filter: (time: any) =>
        this._pipe.tables().style_warner(time, 1250, 1800),
    },
  ];

  // chartsConf_device: ChartConfiguration[] = [
  //   {
  //     id: "ch5",
  //     labels    :   {
  //       isColumn: false
  //     },
  //     columns   :   [
  //       {
  //         label : "served",
  //         name  : "tables.dashboard.counters.labels.served",
  //       },
  //       {
  //         label : "lastCalledTicket",
  //         name  : "tables.dashboard.counters.labels.lastCalledTicket",
  //         pipe  : (value: any)  => this._pipe.tables().excapeText(value, "0")
  //       },
  //     ] ,
  //     type      : 'bar'
  //   },
  //   {
  //     id: "ch6",
  //     labels    :   {
  //       isColumn: false
  //     },
  //     columns   :   [
  //       {
  //         label       : "avgWaitTime",
  //         name        : "tables.dashboard.counters.labels.avgWaitTime",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "maxWaitTime",
  //         name        : "tables.dashboard.counters.labels.maxWaitTime",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label       : "avgWaitTimeToServe",
  //         name        : "tables.dashboard.sites.labels.avgWaitTimeToServe",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label : "maxWaitTimeToServe",
  //         name  : "tables.dashboard.sites.labels.maxWaitTimeToServe",
  //         pipe        : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0"),
  //       },
  //       {
  //         label : "avgServiceTime",
  //         name  : "tables.dashboard.counters.labels.avgServiceTime",
  //         pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "0")
  //       }
  //     ] ,
  //     type      : 'bar'
  //   }
  // ]

  site: Site;
  dashboardFilter: any;

  sitesData: any[];
  countersData: any[];
  servicesData: any[];

  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect) {
    if (siteSelect) {
      setTimeout(() => this.setSite(siteSelect.currentValue), 0);
    }
  }

  @ViewChild('radioManager') set _dashboardFilter(
    dashboardFilter: CustomRadio
  ) {
    if (dashboardFilter) {
      setTimeout(() => this.setFilter(dashboardFilter.currentValue), 0);
    }
  }

  values: Dashboard;

  constructor(
    private _handler: HandlerManager,
    private _loader: LoadingManager,
    private _dialog: MatDialog,
    private _session: SessionManager,
    private _pipe: PipeManager
  ) {}

  ngOnInit(): void {}

  async getDashboard(filter?: string) {
    if (this.site && this.dashboardFilter) {
      const value = this.dashboardFilter.value;
      this.values = undefined;

      //if ( !filter || filter == "SI" ) this.siteTable    .reloadData()
      //if ( !filter || filter == "SE" ) this.serviceTable .reloadData()
      //if ( !filter || filter == "DE" ) this.deviceTable  .reloadData()

      this.siteTable.reloadData();
      this.serviceTable.reloadData();
      this.deviceTable.reloadData();

      this.values = await this.retriveValues(this.site.id, value);

      //if ( !filter || filter == "SI" ) this.siteTable    .dataLoaded()
      //if ( !filter || filter == "SE" ) this.serviceTable .dataLoaded()
      //if ( !filter || filter == "DE" ) this.deviceTable  .dataLoaded()

      this.siteTable.dataLoaded();
      this.serviceTable.dataLoaded();
      this.deviceTable.dataLoaded();

      /*
      if ( !filter || filter == "SI" )
        this.sitesData    = addIdsToArray ( this.getArrayKey('sites'    ) )
      if ( !filter || filter == "SE" )
        this.servicesData = addIdsToArray ( this.getArrayKey('services' ) )
      if ( !filter || filter == "DE" )
        this.countersData = addIdsToArray ( this.getArrayKey('counters' ) )
      */

      this.sitesData = addIdsToArray(this.getArrayKey('sites'));
      this.servicesData = addIdsToArray(this.getArrayKey('services'));
      this.countersData = addIdsToArray(this.getArrayKey('counters'));
    }
  }

  mergeArrayKey(key: string) {
    let book = [];
    let ticket = [];
    if (!this.values) return [];
    if (this.values.book)
      if (this.values.book[key]) book = this.values.book[key];
    if (this.values.ticket)
      if (this.values.ticket[key]) ticket = this.values.ticket[key];

    for (let i = 0; i < book.length; i++) {
      let b = book[i];
      let t = book[i];
      for (let key in b) {
        b[key] += t[key];
      }
    }
    return book;
  }

  getArrayKey(key: string, value?: number) {
    let book = [];
    let ticket = [];
    if (!this.values) return [];
    if (this.values.book)
      if (this.values.book[key]) book = this.values.book[key];
    if (this.values.ticket)
      if (this.values.ticket[key]) ticket = this.values.ticket[key];

    this.appendColumn(book, 'generic.book');
    this.appendColumn(ticket, 'generic.ticket');

    return this.merge(book, ticket);
  }

  appendColumn(array: any[], type: string) {
    array.forEach((element) => {
      element.type = type;
    });
  }

  showType(): boolean {
    if (!this.dashboardFilter || !this.dashboardFilter.value) return false;
    const value = this.dashboardFilter.value;
    return value == 2;
  }

  async retriveValues(siteId: number, type: number) {
    const user = this._session.user().get();

    if (!User.isKind(user)) return; // TODO handle user incorrect

    this._loader.start();

    let response = await this._handler
      .dashboard()
      .getAll((user as User).token, siteId, type);

    this._loader.stop();

    if (!response) return;

    return response as Dashboard;
  }

  merge(array1: any[], array2: any[]) {
    return array1.concat(array2);
  }

  setSite(site: Site) {
    this.site = site;
    this.getDashboard();
  }

  setFilter(value: any) {
    this.dashboardFilter = value;
    this.getDashboard();
  }

  deviceStatus() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    // dialogConfig.width = '90%';
    // dialogConfig.height = '90%';

    let dialog: any;

    dialogConfig.data = {
      siteId: this.site.id,
    };

    dialog = this._dialog.open(DeviceStatusDialog, dialogConfig);
  }
}
